<template>
	<div>
		<div ref='component' id="myChart6"></div>
	</div>
</template>

<script>
import request from "@/utils/request.js";
import { post } from "@/api/requrestHttp";
export default {
    props:['dataTime3'],
    data() {
		this.isEchart = ''
		return {
            hourLsit:[],
            totalLsitList:[],
        }
	},
    watch:{
        dataTime3(){
            // this.getCurrentCallID()
            this.getPlayback()
        }
    }, 
    created() {
	},
	mounted() {
        if (localStorage.getItem("czUserInfo")) {
            var username = JSON.parse(localStorage.getItem("czUserInfo")).loginName;
            this.username = username;
            console.log(this.username,"asda");
        }
		// this.getPlayback()
	},
    methods: {
        async getPlayback() {
			const res = await post("/jjyl/ivrCallInfo/info/findIvrCallInfo", {
				belongAddressId: '4812088f-d02b-4cbe-8dfe-55ad8813df23',
				pageSize: 1000,
				pageNo: 1,
				startTime: this.dataTime3,
                username:  this.username,
				isCall:2,
			});
			//   console.log(res,"afdsa");
			const { code, content } = res;
			// console.log(res.content,"asadc")
			if (code === 200) {
                this.totalLsit = content.list.filter(isat =>{
					if(isat.total){
						return isat.total
					}
				}).map(isDate =>{
					return isDate.total
				})
			    // this.totalLsit = content.list.map(isat =>{
				// 	if(isat.total){
				// 		return isat.total
				// 	}
				// })
                 this.hourList = content.list.filter(isat =>{
					if(isat.total){
						return isat.hours
					}
				}).map(isDate =>{
					return isDate.hours
				})
                // this.hourList = content.list.map(isat =>{
				// 	if(isat.total){
				// 		return isat.hours
				// 	}
				// })
            }
            this.drawLine(this.hourList,this.totalLsit)
        },
        drawLine(hourList,totalLsit){
            this.isEchart = this.$echarts.init(document.getElementById('myChart6'));
			this.$echarts.init(this.$refs.component, null, {
				renderer: 'canvas'
			})
            this.isEchart.setOption({
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'axis'
                },
                // legend: {
                //     data: ['邮件营销', '联盟广告', '视频广告', '直接访问', '搜索引擎']
                // },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: hourList
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        // name: '邮件营销',
                        type: 'line',
                        stack: '总量',
                        data: totalLsit
                    }
                ]
            })
        }
    },
    beforeDestroy() {
		if (this.isEchart) {
			this.isEchart.clear();
		}
	}
}
</script>

<style lang="less" scoped>
    #myChart6 {
		width: 100%;
		height: 460px;
	}
</style>